import { render, staticRenderFns } from "./dilu-uploadimages.vue?vue&type=template&id=666ab57c&scoped=true&"
import script from "./dilu-uploadimages.vue?vue&type=script&lang=js&"
export * from "./dilu-uploadimages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666ab57c",
  null
  
)

export default component.exports